// src/modules/app-views/_apps/appmulti/leads/pages/Init/components/tableColumns/passengersColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tooltip } from 'antd';
import translateX from 'utils/translateX';
import leadsService from '../../../../service';

// *******************************************************************************
// COLUMN FUNCTION
// Age-band icons from quotations[0].passengers (verbatim backup List.jsx:134-167)
// *******************************************************************************
function passengersColumn(buildColumnProps) {
  return {
    key: 'passengers',
    title: translateX('passengers'),
    dataIndex: 'passengers',
    ...buildColumnProps('passengers'),
    align: 'left',
    render: (_, record) => {
      const passengers = record?.customData?.quotations?.[0]?.passengers || [];
      if (!passengers.length) return '—';
      return (
        <PassengerIcons passengers={passengers} />
      );
    },
  };
}

// *******************************************************************************
// HELPERS
// *******************************************************************************
const PassengerIcons = ({ passengers }) => (
  <span className="d-flex gap-1 flex-wrap">
    {passengers.map((age, i) => {
      const AgeIcon = leadsService.getAgeIcon(age);
      return (
        <Tooltip key={i} title={translateX('age_year_old', { AGE: age })}>
          <span><AgeIcon /></span>
        </Tooltip>
      );
    })}
  </span>
);

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default passengersColumn;
